import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthContextProvider } from "./context/AuthContext"
import { PlanContextProvider } from "./context/PlanContext"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <PlanContextProvider>
          <App />
        </PlanContextProvider>
      </AuthContextProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
